<template>
  <div v-if="isLoaded" :class="{ 'opacity-75': isLoading }">
    <div class="bg-primary w-100 h-333 position-relative pt-4 z-index-1">
      <div>
        <div class="row text-center px-3 px-md-5 mx-0 d-md-none">
          <div class="dropdown-container pe-lg-3">
            <button @click="toggleDropdown" class="w-100 uv-search-input-dark font-Pr4">
              <input type="text" v-model="searchQuery" placeholder="Revisá el índice UV en tu ciudad..."
                @input="toggleDropdown" class="input-button" />
            </button>
            <div v-if="dropdownOpen" class="dropdown-container">
              <ul class="dropdown-list">
                <li v-for="location in getOrderedLocations" :key="location.name" @click="selectCity(location)"
                  class="dropdown-item font-Pr" tabindex="0">
                  {{ location.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="parent-element px-3 d-md-none">

        <div class="child-element pb-2" style="overflow-x: auto;">
          <div class="d-flex flex-nowrap">
            <div
              class="card border-0 bg-transparent me-3"
              v-for="(province, index) in provinces"
              :key="index"
              style="flex-shrink: 0;"
            >
              <div class="card-body bg-primary city-cards p-3" @click="selectCity(province)" type="button">
                <h5 class="card-title max-content text-white font-P7 h4" style="white-space: nowrap;">
                  {{ province.name }}
                </h5>
                <p class="p-sm card-text max-content text-white text-primary3">
                  Ver índice UV
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 bg-secondary px-3">
          <div class="card max-w-972 bg-transparent custom-cards mx-auto bg-secondary border-0 mt-5">
            <div class="col-12 bg-white mb-3 card-border p-4 z-index-2 mx-auto">
              <div class="d-none d-md-flex">
                <span class="mt-3 me-4 text-nowrap font-Pr4">Revisá el índice UV en tu zona: </span>
                <div class="w-100">
                  <div class="dropdown-container">
                    <button @click="toggleDropdown" class="w-100 uv-search-input-dark font-Pr4">
                      <input type="text" v-model="searchQuery" placeholder="Seleccionar ciudad..."
                        @input="toggleDropdown" class="input-button" />
                    </button>
                    <div v-if="dropdownOpen" class="dropdown-container">
                      <ul class="dropdown-list">
                        <li v-for="location in getOrderedLocations" :key="location.name" @click="selectCity(location)"
                          class="dropdown-item" tabindex="0">
                          {{ location.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="d-none d-md-block my-4 custom-hr" />

              <CardCarousel class="d-none d-md-block" :provinces="provinces" @select-location="selectCity" />

              <hr class="d-none d-md-block my-4 custom-hr" />
              <h3 class="text-center h3-md mb-0 font-P22">
                <span v-if="selectedLocation">{{ selectedLocation.ciudad }}, {{ selectedLocation.provincia }}</span>
                <span v-else>Capital Federal</span>
              </h3>
              <div class="row">
                <div class="col-12 text-center d-md-flex flex-md-column col-md-6 mb-5 pb-5">
                  <div class="wrapper">
                    <div id="chart" ref="chart"></div>
                    <div class="chart-data">
                      <div>
                        <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M64.9717 36.5698C64.1479 36.5274 63.5185 35.8249 63.5185 35C63.5185 34.1751 64.1479 33.4726 64.9717 33.4302L68.1279 33.2674C69.1359 33.2154 70 33.9907 70 35C70 36.0093 69.1359 36.7846 68.1279 36.7326L64.9717 36.5698ZM59.7009 20.7367C60.114 21.4505 61.011 21.746 61.7456 21.371L64.5556 19.9363C65.4573 19.476 65.8178 18.3665 65.3108 17.4903C64.8037 16.6141 63.6652 16.3786 62.8167 16.9308L60.1722 18.6516C59.4809 19.1014 59.2878 20.0229 59.7009 20.7367ZM49.2633 10.2991C49.9771 10.7122 50.8986 10.519 51.3484 9.82778L53.0692 7.18329C53.6214 6.33475 53.3859 5.19629 52.5097 4.68922C51.6335 4.18216 50.524 4.54273 50.0637 5.44438L48.629 8.25444C48.254 8.98898 48.5495 9.88601 49.2633 10.2991ZM35 6.48148C35.8249 6.48148 36.5274 5.85208 36.5698 5.0283L36.7326 1.87212C36.7846 0.86414 36.0093 0 35 0C33.9907 0 33.2154 0.86414 33.2674 1.87212L33.4302 5.02829C33.4726 5.85208 34.1751 6.48148 35 6.48148ZM20.7367 10.2991C21.4505 9.88601 21.746 8.98898 21.371 8.25444L19.9363 5.44439C19.476 4.54273 18.3665 4.18216 17.4903 4.68923C16.6141 5.19629 16.3786 6.33475 16.9308 7.18329L18.6516 9.82778C19.1014 10.519 20.0229 10.7122 20.7367 10.2991ZM10.2991 20.7367C10.7122 20.0229 10.519 19.1014 9.82778 18.6516L7.18329 16.9308C6.33475 16.3786 5.19629 16.6141 4.68922 17.4903C4.18216 18.3665 4.54273 19.476 5.44438 19.9363L8.25444 21.371C8.98898 21.746 9.88601 21.4505 10.2991 20.7367ZM5.0283 33.4302C5.85208 33.4726 6.48148 34.1751 6.48148 35C6.48148 35.8249 5.85208 36.5274 5.02829 36.5698L1.87212 36.7326C0.86414 36.7846 0 36.0093 0 35C0 33.9907 0.86414 33.2154 1.87212 33.2674L5.0283 33.4302ZM10.2991 49.2633C9.88601 48.5495 8.98898 48.254 8.25444 48.629L5.44439 50.0636C4.54273 50.524 4.18216 51.6334 4.68922 52.5097C5.19629 53.3859 6.33475 53.6214 7.18329 53.0692L9.82778 51.3484C10.519 50.8986 10.7122 49.9771 10.2991 49.2633ZM20.7367 59.7009C20.0229 59.2878 19.1014 59.4809 18.6516 60.1722L16.9308 62.8167C16.3786 63.6652 16.6141 64.8037 17.4903 65.3108C18.3665 65.8178 19.476 65.4573 19.9363 64.5556L21.371 61.7456C21.746 61.011 21.4505 60.114 20.7367 59.7009ZM35 63.5185C34.1751 63.5185 33.4726 64.1479 33.4302 64.9717L33.2674 68.1279C33.2154 69.1359 33.9907 70 35 70C36.0093 70 36.7846 69.1359 36.7326 68.1279L36.5698 64.9717C36.5274 64.1479 35.8249 63.5185 35 63.5185ZM49.2633 59.7009C48.5495 60.114 48.254 61.011 48.629 61.7456L50.0636 64.5556C50.524 65.4573 51.6334 65.8178 52.5097 65.3108C53.3859 64.8037 53.6214 63.6652 53.0692 62.8167L51.3484 60.1722C50.8986 59.4809 49.9771 59.2878 49.2633 59.7009ZM59.7009 49.2633C59.2878 49.9771 59.4809 50.8986 60.1722 51.3484L62.8167 53.0692C63.6652 53.6214 64.8037 53.3859 65.3108 52.5097C65.8178 51.6335 65.4573 50.524 64.5556 50.0637L61.7456 48.629C61.011 48.254 60.114 48.5495 59.7009 49.2633Z"
                            :fill="getValueColor" />
                          <path
                            d="M57.963 34.9815C57.963 47.6738 47.6738 57.963 34.9815 57.963C22.2892 57.963 12 47.6738 12 34.9815C12 22.2892 22.2892 12 34.9815 12C47.6738 12 57.963 22.2892 57.963 34.9815Z"
                            :stroke="getValueColor" stroke-width="2" stroke-linejoin="round" />
                          <path
                            d="M27.5547 43.216C25.9347 43.216 24.6447 42.856 23.6847 42.136C22.7247 41.404 22.2447 40.24 22.2447 38.644V31.21H20.7147V29.932H25.7547V31.21H24.2787V38.356C24.2787 39.568 24.5667 40.432 25.1427 40.948C25.7187 41.452 26.5587 41.704 27.6627 41.704C28.6947 41.704 29.4987 41.434 30.0747 40.894C30.6627 40.354 30.9567 39.526 30.9567 38.41V31.21H29.5527V29.932H34.1967V31.21H32.7567V38.536C32.7567 39.22 32.6547 39.838 32.4507 40.39C32.2467 40.93 31.9767 41.374 31.6407 41.722C31.3047 42.07 30.9087 42.358 30.4527 42.586C29.9967 42.814 29.5287 42.976 29.0487 43.072C28.5687 43.168 28.0707 43.216 27.5547 43.216ZM40.8108 43.054L36.1128 31.354L34.7628 31.21V29.932H39.7308V31.21H38.2008L41.6028 40.012L41.9448 41.056H41.9988L42.3408 39.976L45.7788 31.21H44.0688V29.932H48.8748V31.246L47.5068 31.372L42.6648 43.054H40.8108Z"
                            :fill="getValueColor" />
                        </svg>
                      </div>
                      <span class="text-primary h3-md d-block font-P22">{{ getValueText }}</span>
                      <span class="d-block h3-md font-P30">{{ uvData.uv_indice.toFixed(2) }}</span>
                      <div class="d-flex justify-content-center ps-4" v-if="uvData">
                        <span class="icon-clock align-items-center"></span>
                        <p class="p-sm align-items-center mb-0 font-Pr4">
                          {{ getTime() }}
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
                <!-- Spinner -->
                <div class="loader loader--visible" v-if="isLoading">
                  <div class="lds-dual-ring"></div>
                </div>
                <!-- End of Spinner -->
                <div class="d-md-flex flex-md-column col-md-6 pt-3">
                  <h4 class="h4-sm font-P22 text-primary my-4">
                    {{ recommendation.title }}
                  </h4>
                  <p class="p-sm lh-30 mb-4 font-P14">
                    {{ recommendation.description }}
                  </p>
                </div>
              </div>
              <hr class="d-none d-md-block my-4 custom-hr" />
              <div class="row align-items-center p-md-2">
                <div class="col-2 col-sm-1 text-center position-relative">
                  <span class="icon-info"></span>
                </div>

                <div class="col-10 col-sm-11">
                  <p class="small mb-0 font-P14">
                    Los valores UV pueden modificarse durante el día. Releve el nivel con
                    frecuencia si realizará actividades al aire libre
                  </p>
                </div>
              </div>
            </div>
            <div class="bg-white references-border">
              <h4 class="h4-sm font-P22 my-3 d-none p-3 d-md-block text-start px-4">
                Referencias
              </h4>
              <div class="row mx-0 bg-white references-border justify-content-center pb-md-5">
                <h4 class="h4-sm text-center font-P22 mb-3 d-md-none pt-5">Referencias</h4>

                <div class="d-flex align-items-center text-center pb-5 pb-md-0 col-12 col-md-25"
                  v-for="ellipse in ellipses" :key="ellipse.range">
                  <div class="w-100 text-end">
                    <img class="me-3" :src="ellipse.path" />
                  </div>
                  <div class="w-100 text-start mt-4">
                    <span class="d-block font-P18">{{ ellipse.range }}</span>
                    <span class="d-block font-P14">{{ ellipse.value }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-secondary d-flex pt-5">
              <div class="container">
                <div class="col-12 text-secondary2 mx-auto px-3 w-100">
                  <p class="small lh-30-md mb-0 font-A400">Se deja constancia de que el contenido de este sitio es
                    estimado y a los efectos informativos, basado en un modelo matemático desarrollado. Se recomienda
                    siempre consultar a un médico para conocer los riesgos de exposición a la radiación y las
                    recomendaciones para un diagnóstico o tratamiento específico. Los valores UV pueden variar durante
                    el día. Revíselos si va a estar expuesto al sol. Fuente: https://www.openuv.io/terms</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Spinner -->
  <div class="loader loader--visible" v-else>
    <div class="lds-dual-ring"></div>
  </div>
  <!-- End of Spinner -->
</template>
<script>
import * as c3 from 'c3';
import * as d3 from 'd3';
import "c3/c3.min.css";
import UltravioletRaysService from '../../services/UltravioletRaysService';
import CardCarousel from './CardCarousel.vue';
import vueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  components: {
    CardCarousel,
    vueCustomScrollbar
  },
  name: 'ultravioletrays',
  props: {
    provinces: Array,
    locations: Array
  },
  data() {
    return {
      selectedLocation: {},
      searchQuery: '',
      recommendations: null,
      recommendation: null,
      uvData: null,
      isLoading: false,
      isLoaded: false,
      dropdownOpen: false,
      ops: {
        rail: {
          background: '#7267c3',
          opacity: 1,
          size: '12px',
          specifyBorderRadius: false,
          gutterOfEnds: null,
          gutterOfSide: '-5px',
          keepShow: false
        },
        bar: {
          background: 'white'
        }
      },
      ellipses: [
        { path: '/images/icons/green_ellipse.svg', range: '1 - 2', value: 'Bajo' },
        { path: '/images/icons/orange_ellipse.svg', range: '3 - 4 - 5', value: 'Moderado' },
        { path: '/images/icons/dark_orange_ellipse.svg', range: '6 - 7', value: 'Alto' },
        { path: '/images/icons/red_ellipse.svg', range: '8 - 9 - 10', value: 'Muy Alto' },
        { path: '/images/icons/violet_ellipse.svg', range: '11+', value: 'Extremo' }
      ]
    };
  },
  created() {
    this.initRecommendations();
    this.getUltravioletRays();
    this.getGeolocation();
  },
  methods: {
    getGeolocation() {
      const parent = this;
      if (!navigator.geolocation) {
        console.log('Geolocation is not supported by your browser');
      } else {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            parent.getUltravioletRays(
              position.coords.latitude,
              position.coords.longitude
            );
          },
          function () {
            if (process.env.MIX_ENV != 'https://lnbienestar.lanacion.com.ar' || 'https://qa-lnbienestar.lanacion.com.ar') {
              console.log('Unable to retrieve your location');
            }
          }
        );
      }
    },
    initRecommendations() {
      const titlesArr = [
        'Buenas noticias',
        'Estate atento',
        'Cuidado, a protegerse',
        'Alto riesgo',
        'Peligro'
      ];
      const descriptionsArr = [
        'Es el nivel más bajo de radiación ultravioleta, de todas formas se aconseja el uso de bloqueador solar y anteojos de sol, además de evitar la exposición entre las 10 AM y las 12 PM.',
        'Se aconseja utilizar un protector solar con un filtro mínimo de 30, que se debe elevar a 50 durante los meses de primavera y de verano, además del uso de lentes de sol. Evitar los lugares al aire libre sin áreas de sombra entre las 10 AM y las 2 PM. Hay que tener en cuenta que el bloqueador solar protege, pero no es suficiente cuando la radiación es moderada, alta o altísima.',
        'Los dermatólogos ya consideran que este nivel de radiación lastima la piel aún en horarios en los que la intensidad de la radiación ultravioleta del sol es menor (fuera del horario del mediodía). Se aconseja utilizar bloqueador solar, anteojos de sol y tomar agua.',
        'No exponerse al sol en ningún momento del día, tomar mucha agua y utilizar bloqueador solar, lentes de sol y sombrero. Preferentemente se aconseja caminar o instalarse en áreas con sombra. Si trabaja al aire libre se aconseja el uso de prendas de manga larga y pantalones más allá de la sensación térmica.',
        'Es el mayor nivel de radiación. Además de utilizar bloqueador solar, sombrero y anteojos de sol; evitar el contacto directo de la piel con el sol en todo momento del día. Tener contacto con el sol con este nivel de radiación genera daños cutáneos, en los ojos y en el sistema inmunológico; y puede aumentar las posibilidades de sufrir cáncer de piel.'
      ];

      const result = titlesArr.map((item, index) => ({
        title: item,
        description: descriptionsArr[index]
      }));

      this.recommendations = result;
    },
    getRecommendation() {
      const uvIndex = this.uvData.uv_indice;
      const recommendations = this.recommendations;

      this.recommendation =
        uvIndex < 3
          ? recommendations[0]
          : uvIndex >= 3 && uvIndex < 6
            ? recommendations[1]
            : uvIndex >= 6 && uvIndex < 8
              ? recommendations[2]
              : uvIndex >= 8 && uvIndex < 11
                ? recommendations[3]
                : recommendations[4];
    },
    async getUltravioletRays(lat, lon) {
      this.isLoading = true;

      const response = (
        await UltravioletRaysService.getUltravioletRays(lat, lon)
      ).data;

      this.uvData = response;

      this.selectedLocation.ciudad = this.uvData.ciudad;
      this.selectedLocation.provincia = this.uvData.provincia;

      this.getRecommendation();
      this.isLoading = false;
      this.isLoaded = true;
    },
    selectCity(location) {
      this.selectedLocation = location;
      this.searchQuery = '';
      this.dropdownOpen = false;
      this.getUltravioletRays(
        location.coordinates.lat,
        location.coordinates.lon
      );
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    getTime() {
      let time = new Date(this.uvData.uv_hora);
      time =
        time.getHours() +
        ':' +
        (time.getMinutes() < 10 ? '0' : '') +
        time.getMinutes() +
        ' hs.';
      return time;
    },
    retrieveGraph() {
      const uvIndex = this.uvData?.uv_indice;
      if (!uvIndex || !this.isLoaded) return;
      if (process.env.MIX_ENV != 'https://lnbienestar.lanacion.com.ar' || 'https://qa-lnbienestar.lanacion.com.ar') {
        // console.log('uvIndex from retrieveGraph', uvIndex);
      }
      this.$nextTick(() => {
        if (!this.$refs.chart) return;
        var chart = c3.generate({
          bindto: '#chart',
          data: {
            columns: [['UV', uvIndex]],
            type: 'gauge',
            onclick: function (d, i) {
              console.log('onclick', d, i);
            },
            onmouseover: function (d, i) {
              console.log('onmouseover', d, i);
            },
            onmouseout: function (d, i) {
              console.log('onmouseout', d, i);
            }
          },
          legend: {
            show: false
          },
          gauge: {
            label: {
              format: function (value, ratio) {
                return '';
              }
            },
            max: 11,
            width: 20
          },
          color: {
            pattern: ['#9DC600', '#FFBB01', '#FF9100', '#F1561C', '#9B48CE'],
            threshold: {
              unit: 'value',
              max: 100,
              values: [2.99, 5.99, 7.99, 10.99]
            }
          },
          size: {
            height: 180
          },
          onrendered: function () {
            d3.select('.c3-chart-arcs-gauge-max').text('11+');
            d3.selectAll('.c3-chart-arcs-background').style('fill', '#E8E7F5');
            d3.selectAll('text').style('font-size', '14px');
          }
        });
      });
    }
  },
  computed: {
    getValueText() {
      const uvIndex = this.uvData.uv_indice;
      return uvIndex < 3
        ? 'Bajo'
        : uvIndex >= 3 && uvIndex < 6
          ? 'Moderado'
          : uvIndex >= 6 && uvIndex < 8
            ? 'Alto'
            : uvIndex >= 8 && uvIndex < 11
              ? 'Muy Alto'
              : 'Extremo';
    },
    getValueColor() {
      const uvData = this.uvData.uv_indice;
      return this.uvData.uv_indice < 3
        ? '#9DC600'
        : uvData.uv_indice >= 3 && uvData.uv_indice < 6
          ? '#FFBB01'
          : uvData.uv_indice >= 6 && uvData.uv_indice < 8
            ? '#FF9100'
            : uvData.uv_indice >= 8 && uvData.uv_indice < 11
              ? '#F1561C'
              : '#9B48CE';
    },
    getOrderedLocations() {
      return this.locations
        .filter(location =>
          location.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
        .sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        }
        );
    }
  },
  watch: {
    selectedLocation: {
      handler() {
        this.retrieveGraph();
      },
      deep: true
    },
    uvData: {
      handler() {
        this.retrieveGraph();
      },
      deep: true
    },
    isLoaded: {
      handler() {
        this.retrieveGraph();
      },
      deep: true
    },
  }
}
</script>

<style lang="scss" scoped>
.opacity-75 {
  opacity: 0.75;
}

.child-element {
  @media (min-width: 375px) {
    padding-top: 0.5rem;
    margin-top: 0.5rem;
  }
}
::v-deep(.child-element) {
  scrollbar-color: white transparent;
  scrollbar-width: thin;
  overflow-x: scroll
}

.wrapper {
  height: 100%;
  width: 100%;
  position: relative;
}

#chart {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.chart-data {
  position: absolute;
  margin: auto;
  top: 90px;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;

  @media (min-width: 375px) {
    top: 75px;
  }
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;

  &:after {
    content: ' ';
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #7267c3;
    border-color: #7267c3 transparent #7267c3 transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loader {
  z-index: 100000000;
  background: transparent;
  transition: 0.15s ease-in opacity;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: 0;

  &--visible {
    opacity: 1;
    pointer-events: all;
  }
}

.lh-30-md {
  @media (min-width: 768px) {
    line-height: 30px;
  }
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
}
</style>
